
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PlusCircle } from "lucide-react";
import { University } from "@/services/universityService";

interface UniversitySelectorProps {
  universities: University[];
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  onAddNew: () => void;
}

const UniversitySelector: React.FC<UniversitySelectorProps> = ({ 
  universities, 
  value, 
  onChange, 
  readOnly = false,
  onAddNew
}) => {
  return (
    <Select
      disabled={readOnly}
      onValueChange={onChange}
      value={value}
    >
      <SelectTrigger>
        <SelectValue placeholder="Select a university" />
      </SelectTrigger>
      <SelectContent>
        {universities.map((university) => (
          <SelectItem key={university.id} value={university.id}>
            {university.name}
          </SelectItem>
        ))}
        {!readOnly && (
          <SelectItem value="add_new" className="text-primary">
            <div className="flex items-center">
              <PlusCircle className="mr-2 h-4 w-4" />
              Add new university
            </div>
          </SelectItem>
        )}
      </SelectContent>
    </Select>
  );
};

export default UniversitySelector;
